
export interface NavigationState {
    selectedClientId: string | null;
    editClientId: string | null;
    selectedTaskIndex: number;
    selectedSessionIndex: number;
    selectedFolderIndex: number;
    selectedBottomMenuTabId: string;
    selectedLeftMenuTabIndex: number;
    activeTag: string;
    isDashWrap: boolean;
    isLeftCollapsed: boolean;
    showMenu: boolean;
    activePopup: string;
    sideSelected: string;
    bottomSelected: string | undefined;
    isDashboardVisible: boolean;
    searchValue: string;
}

const NAVIGATION_STATE_KEY = 'dashboardNavigationState';

export const saveNavigationState = (state: NavigationState): void => {
    try {
        localStorage.setItem(NAVIGATION_STATE_KEY, JSON.stringify(state));
    } catch (error) {
        console.warn('Failed to save navigation state:', error);
    }
};

export const loadNavigationState = (): Partial<NavigationState> => {
    try {
        const savedState = localStorage.getItem(NAVIGATION_STATE_KEY);
        return savedState ? JSON.parse(savedState) : {};
    } catch (error) {
        console.warn('Failed to load navigation state:', error);
        return {};
    }
};

export const clearNavigationState = (): void => {
    try {
        localStorage.removeItem(NAVIGATION_STATE_KEY);
    } catch (error) {
        console.warn('Failed to clear navigation state:', error);
    }
};

export const shouldRestoreState = (): boolean => {
    // Only restore state if user is authenticated and we have saved state
    return localStorage.getItem(NAVIGATION_STATE_KEY) !== null;
};
